import { Textarea } from "@arcadeai/design-system/components/ui/atoms/textarea";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import { useFormContext } from "react-hook-form";
import type { AuthProvider } from "@/app/oauth/types";

export const DescriptionField = () => {
  const form = useFormContext<AuthProvider>();

  return (
    <FormField
      control={form.control}
      name="description"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Description</FormLabel>
          <FormControl>
            <Textarea placeholder="My OAuth Provider" {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
